export interface Problem {
  type: string;
  title: string;
  status: number;
  detail?: string;
  instance?: string;
  // RFC 7807 extension members forwarded by the api (see
  // apps/api/src/common/errors/http-exception.filter.ts). Present on specific
  // problem types — e.g. the checkout single-active-pending 409 carries the
  // in-flight order so the UI can offer "resume / cancel" instead of dead-ending.
  existingOrderId?: string;
  existingPaymentIntentId?: string;
  variantId?: string;
}

export function isProblem(x: unknown): x is Problem {
  return (
    typeof x === "object" &&
    x !== null &&
    typeof (x as Problem).type === "string" &&
    typeof (x as Problem).title === "string" &&
    typeof (x as Problem).status === "number"
  );
}
